module.exports = __webpack_public_path__ + "img/award_img02.5c5d90cf.jpg";